// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCYTYA3szEb-VzkPIN_dJo8JWXNO0bVVE8",
    authDomain: "aryakulam-international-school.firebaseapp.com",
    databaseURL: "https://aryakulam-international-school-default-rtdb.firebaseio.com",
    projectId: "aryakulam-international-school",
    storageBucket: "aryakulam-international-school.firebasestorage.app",
    messagingSenderId: "1042735136361",
    appId: "1:1042735136361:web:dc4d5ab8021062847c2cf8",
    measurementId: "G-GRQWD1YGFZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an cerror is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
